import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { ModalHeader } from '~/components/Modal/components/ModalHeader';
import Modal from '~/components/Modal/Modal';

interface DescriptionModalV3Props {
  open: boolean;
  title: string;
  text: string;

  onClose(): void;
}

const DescriptionModalV3 = ({
  open,
  title,
  text,
  onClose,
}: DescriptionModalV3Props) => {
  useEffect(() => {
    if (!open) {
      return;
    }

    document.body.classList.add('body-no-scroll');

    return () => document.body.classList.remove('body-no-scroll');
  }, [open]);

  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <Modal
      isShow={open}
      onBackdropDismiss={onClose}
      className="overflow-hidden! top-auto! bottom-0! left-0! flex max-h-[85svh] w-full! flex-col rounded-t-[24px]! rounded-b-none! p-0! [transform:none]! lg:top-1/2! lg:bottom-auto! lg:left-1/2! lg:max-h-[80vh]! lg:w-[560px]! lg:max-w-[calc(100vw-32px)]! lg:rounded-[32px]! lg:[transform:translate(-50%,-50%)]!"
    >
      <div className="shrink-0 lg:px-8">
        <ModalHeader title={title} onClose={onClose} />
      </div>
      <p className="m-0 min-h-0 flex-1 overflow-y-auto overflow-x-hidden whitespace-pre-line px-4 pb-4 text-text-secondary [font:var(--text-300-regular-high)] lg:px-8 lg:pb-6">
        {text}
      </p>
    </Modal>,
    document.body,
  );
};

export default DescriptionModalV3;
